import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { CompanyInterface } from '@app/interface/company';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';

// import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CompanyApi extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
    private route: ActivatedRoute, // Inject ActivatedRoute
    private http: HttpClient,
    private tokenExtractor: HttpXsrfTokenExtractor
  ) {
    super(auth, httpClient);
  }

  public getCompanyList<T = CompanyInterface>(
    // projectId: number,
    params: httpQueryParams = {}
  ): Observable<PaginatedResponse<T>> {
    let organization_id = 1;
    // const organization_id = this.route.snapshot.paramMap.get('organizationId');

    // if (!organization_id) {
    //   throw new Error('Organization ID is required');
    // }

    let path = `api/${organization_id}/company/`;
    return this.getList<T>(path, params);
  }

  // using getRecursivePage
  public getAllCompanies<T = CompanyInterface>(
    organization_id: number | null,
    params: httpQueryParams = {}
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/company/`;
    console.log(path);
    return this.getRecursivePage<T>(path, params);
  }

  public getSpecificCompany<T = CompanyInterface>(
    organization_id: number,
    company_id: number,
    params: httpQueryParams = {}
  ): Observable<CompanyInterface> {
    const path = `api/${organization_id}/company/${company_id}/`;
    console.log(path);
    return this.get<CompanyInterface>(path, params);
  }

  public createCompany(
    organization_id: number | null,
    companyData: Partial<CompanyInterface>
  ): Observable<CompanyInterface> {
    const path = `api/${organization_id}/company/`;

    return this.post<CompanyInterface>(path, {}, companyData);
  }

  public updateCompanyDetails(
    organization_id: number | null,
    id: number,
    data: Partial<CompanyInterface>
  ): Observable<CompanyInterface> {
    console.log(data);
    return this.partialUpdate<CompanyInterface>(
      `api/${organization_id}/company/${id}/`,
      {}, //{ withCredentials: true },
      data
    );
  }

  uploadCompanyExcel(organizationId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    const path = `api/${organizationId}/companies/upload-company-list-from-excel/`;

    // Get CSRF token
    const csrfToken = this.tokenExtractor.getToken() || '';

    let headers = new HttpHeaders();
    // Don't set Content-Type for FormData - let browser set it with boundary
    headers = headers.set('X-CSRFToken', csrfToken);

    return this.http.post(`${environment.backendDomain}/${path}`, formData, {
      headers,
      reportProgress: true,
      observe: 'events',
      withCredentials: true, // Important for CSRF cookies
    });
  }
}
